import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-settings-icon',
  templateUrl: './shopping-settings.component.html'
})
export class ShoppingSettingsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
